import 'Careers/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const DeferralLinkDirective = angularDirectiveToReact('deferralLink', { id: 'string' });

type Props = {
    id?: string;
};

export function DeferralLinkComponent({ id }: Props) {
    const [key] = useAngularToReactRoute();
    return <DeferralLinkDirective key={key} id={id} />;
}
